/**
 * Design tokens — JS mirror of src/styles/tokens.scss.
 *
 * The SCSS file remains canonical for stylesheets; this module exists so
 * TypeScript code (notably clockThemes.ts) consumes the same palette.
 *
 * Keep both files in sync. A unit test verifies parity.
 */

export const tokens = {
  // Primary
  sunYellow: '#F2C94C',
  inkBlack: '#1C1C1C',
  paperCream: '#FAF9F6',

  // Secondary / accent
  softRed: '#D65A4A',
  lavenderPurple: '#9B8ED8',
  skyBlue: '#5DADE2',
  warmOrange: '#E09F3E',

  // Extended
  cream: '#F8E8D9',
  teal: '#32B197',
  mint: '#98D8CB',
  magenta: '#A51870',
  purpleBlue: '#5C6DB0',
  charcoal: '#1F1F22',
  white: '#FFFFFF',
} as const;

export type ThemeColorToken = keyof typeof tokens;
